<template>
    <div class="navbar-toggle">
        <div class="hamburger-icon" @click="handleClick">
            <Icon
                :icon-name="iconName"
                :size="24"
                style="color: var(--hero-nav-button-text-color)"
                :class="iconClasses"
            />
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Icon from "@/scripts/common/Icon.vue";

    export default {
        name: "HamburgerToggle",
        components: {Icon},
        methods: {
            handleClick() {
                this.viewData.navOpen = !this.viewData.navOpen
            }
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            iconName() {
                return !this.viewData.navOpen ? 'mobile-navigation-hamburger' : 'mobile-navigation-close'
            },
            iconClasses() {
                return {
                    'hamburger': true,
                    'open': !this.viewData.navOpen,
                    'close': this.viewData.navOpen,
                    'nav-open': this.viewData.navOpen,
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
// navigation toggle button on mobile
.navbar-toggle {
    display: none;
    @media (max-width: 768px) {
        position: relative;
        z-index: 11;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        margin-left: auto;

        &.on {
            svg {
                display: block;
            }
        }

        .hamburger-icon {
            height: max-content;
            aspect-ratio: 1;
        }
    }
}
</style>